import { ContentType } from 'graphql/generated/graphql';

interface SpeakerResult {
  id: string;
  name: string;
}

export interface TagResult {
  id: string;
  name: string;
}

interface StoryResult {
  id: string;
  title: string;
  contentType: Pick<ContentType, 'slug'>;
}

export interface GenreResult {
  id: string;
  name: string;
}

export interface ContentTypeResult {
  id: string;
  name: string;
}

export interface LanguageIntensityResult {
  id: string;
  name: string;
}

export enum SearchSortBy {
  Relevance = 'relevance',
  Kinkiness = 'kinkiness',
  New = 'new',
  Popular = 'popular',
}

export interface SearchResults {
  queryIds: {
    speakers: string;
    tags: string;
    stories: string;
    genres: string;
    contentTypes: string;
    languageIntensities: string;
  };
  speakers: SpeakerResult[];
  tags: TagResult[];
  stories: StoryResult[];
  genres: GenreResult[];
  contentTypes: ContentTypeResult[];
  languageIntensities: LanguageIntensityResult[];
}

export interface SearchResponseObject {
  objectID: string;
  name: string;
  name_de: string;
  name_fr_fr: string;
  name_en_gb: string;
  title: string;
  content_type: {
    slug: string;
  };
  slug: string;
}

// See https://github.com/algolia/algoliasearch-client-javascript/blob/3aec216a9704f818b4faaa8b97d988ec2794f9da/packages/transporter/src/errors/createApiError.ts
export interface AlgoliaApiError {
  name: string;
  message: string;
  status: number;
  transporterStackTrace: any[];
}
